"use client";

import React from "react";

//Types
import { ThemeButtonProps } from "@/types";

//Styles
import * as S from "./styles";
import { useTheme } from "next-themes";

const ThemeButton: React.FC<ThemeButtonProps> = ({
  className,
  onClick,
  float = false,
  activeTheme,
}) => {
  const { theme, setTheme } = useTheme();

  const handleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  return (
    <S.SwiperButton onClick={onClick} $float={float}>
      <S.BoxTabSwitch $active={activeTheme ? "true" : "false"} />
      <S.IconButton
        $active={!activeTheme ? "true" : "false"}
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-sun"
      >
        <circle cx="12" cy="12" r="5"></circle>
        <line x1="12" y1="1" x2="12" y2="3"></line>
        <line x1="12" y1="21" x2="12" y2="23"></line>
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
        <line x1="1" y1="12" x2="3" y2="12"></line>
        <line x1="21" y1="12" x2="23" y2="12"></line>
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
      </S.IconButton>
      <S.IconButton
        $active={activeTheme ? "true" : "false"}
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-sun"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
      </S.IconButton>
    </S.SwiperButton>
  );
};

export default ThemeButton;
